module.exports = __webpack_public_path__ + "assets/videos/header-video.mp4?v=809f676d";